// extracted by mini-css-extract-plugin
module.exports = {"btn":"SubmitButton-module__btn","loader":"SubmitButton-module__loader","load-animate":"SubmitButton-module__load-animate","disabled":"SubmitButton-module__disabled"};